export const getRiberaDelDueroData = () => ({
  name: "Ribera del Duero",
  country: "Espagne",
  description: "Ribera del Duero est une région viticole de Castille-et-León, célèbre pour ses vins rouges puissants et complexes, principalement à base de Tinto Fino (Tempranillo).",
  type: "region",
  subregions: [
    { name: "Ribera Alta", area: "8,000 ha", percentage: "36%", description: "Vins équilibrés et élégants" },
    { name: "Ribera Media", area: "6,000 ha", percentage: "27%", description: "Vins de terroir" },
    { name: "Ribera Baja", area: "8,000 ha", percentage: "37%", description: "Vins puissants et structurés" }
  ],
  mapAreas: [
    { region: "Ribera Alta", x: 38, y: 38, color: "#4B164C", size: 5 },
    { region: "Ribera Media", x: 40, y: 40, color: "#6d2c7a", size: 4 },
    { region: "Ribera Baja", x: 42, y: 42, color: "#8a4a8a", size: 5 }
  ],
  statistics: {
    totalArea: "22,000 ha",
    production: "85 million litres",
    wineries: "300+ bodegas",
    appellations: "3 sous-régions",
    exportPercentage: "35%"
  },
  characteristics: {
    climate: "Climat continental extrême avec de grandes amplitudes thermiques",
    soil: "Sols calcaires et argilo-calcaires, galets et sable",
    viticulture: "Vignes en altitude (750-1000m), rendements très limités"
  },
  wineStyles: {
    red: "Vins rouges puissants et structurés, avec des tannins fermes et une complexité aromatique",
    white: "Vins blancs limités, principalement de Verdejo",
    rosé: "Rosés fruités et équilibrés"
  },
  history: "La viticulture à Ribera del Duero remonte aux Romains. Au Moyen Âge, les monastères ont développé la culture du vin. En 1982, la région obtient l'appellation d'origine. Vega Sicilia, fondée en 1864, est la bodega la plus prestigieuse.",
  foodPairing: "Viandes rouges grillées, agneau, gibier, fromages affinés de Castille"
}); 